import { FunctionComponent, ReactElement } from 'react';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';

export type SearchInputProps = TextFieldProps;

const SearchInput: FunctionComponent<SearchInputProps> = (props): ReactElement => (
	<TextField
		{...props}
		size={props.size || 'small'}
		InputProps={{
			endAdornment: (
				<InputAdornment position="end">
					<SearchRounded />
				</InputAdornment>
			),
		}}
		fullWidth
	/>
);

export default SearchInput;
